import { apiSlice, asyncToastDisplay, i18n} from "./apiSlice";

export const dataVendorUserApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDataVendorUsers: builder.query({
      query: (dataVendorId) => (`/data_vendors/${dataVendorId}/users`),
      providesTags: (result , error, dataVendorId) => [{ type: 'User', id: "LIST"}],
    }),
    getDataVendorUser: builder.query({
      query: ({dataVendorId, userId}) => (`/data_vendors/${dataVendorId}/users/${userId}`),
      providesTags: (result , error, {userId}) => [{ type: 'User', id: userId}],
    }),
    createDataVendorUser: builder.mutation({
      query: ({dataVendorId, user}) => ({
        url: `/data_vendors/${dataVendorId}/users/`,
        method: 'POST',
        body: {skipConfirmationNotification: true, ...user}
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [{ type: 'User', id: "LIST"}],
    }),
    updateDataVendorUser: builder.mutation({
      query: ({dataVendorId, user}) => ({
        url: (`/data_vendors/${dataVendorId}/users/${user.userId}`),
        method: 'PUT',
        body: user,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {user}) => [{ type: 'User', id: "LIST"}, { type: 'User', id: user.userId }],
    }),
    deleteDataVendorUser: builder.mutation({
      query: ({dataVendorId, userId}) => ({
        url: (`/data_vendors/${dataVendorId}/users/${userId}`),
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, {userId}) => [{ type: 'User', id: "LIST"}, { type: 'User', id: userId }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetDataVendorUsersQuery,
  useGetDataVendorUserQuery,
  useUpdateDataVendorUserMutation,
  useCreateDataVendorUserMutation,
  useDeleteDataVendorUserMutation
} = dataVendorUserApiSlice
